import script from "./Tickets.vue?vue&type=script&setup=true&lang=js"
export * from "./Tickets.vue?vue&type=script&setup=true&lang=js"

import "./Tickets.vue?vue&type=style&index=0&id=1343f77a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1343f77a"]])

export default __exports__